import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import random from 'lodash/random'

import { reportHeaderBannerClick } from '../../../common/analytics/bannerAnalytics'

class HeadBanner extends React.Component {
  constructor (props) {
    super(props)

    // we should not rendering any thing from server side for two reasons:
    // 1. content will be cached through CDN, and we don't want it to be cached
    // 2. we will get react invalid checksum warning because server and client
    // render differnt content
    this.state = {
      bannerConfig: null,
      hideBanner: false,
      hasBindedDismissEvent: false,
      hasBindedClickEvent: false
    }
  }

  componentDidMount () {
    const { banners } = this.props
    const bannerId = banners && banners[0]
      ? banners[0].id
      : null

    if (bannerId) {
      const bannerCacheKey = `banner_${bannerId}_cache`
      const localStorageSupported = !!window.localStorage
      // should not show the banner if it's already dismissed
      const hasDimissed = localStorageSupported
        ? window.localStorage.getItem(bannerCacheKey) === 'hidden'
        : false
      if (localStorageSupported && !hasDimissed) {
        // if it's not dismissed
        // we load random banner config after page is loaded
        const bannerIndex = random(banners.length - 1)
        const bannerConfig = banners[bannerIndex]

        this.setState({
          bannerConfig
        })
      }
    }
  }

  componentDidUpdate () {
    const {
      bannerConfig,
      hasBindedDismissEvent,
      hasBindedClickEvent
    } = this.state
    const dismissButton = document.querySelector('.js-banner__dismiss')
    const bannerLinkButton = document.querySelector('.js-banner__link')
    // only bind the dismiss event when the banner is loaded
    if (dismissButton && !hasBindedDismissEvent) {
      this.bindDismissEvent(bannerConfig)
    }
    if (bannerLinkButton && !hasBindedClickEvent) {
      this.bindBannerClickEvent(bannerConfig)
    }
  }

  bindDismissEvent (bannerConfig) {
    const dismissButton = document.querySelector('.js-banner__dismiss')
    // this should always align with the key set by marketplace
    const bannerCacheKey = `banner_${bannerConfig.id}_cache`

    if (dismissButton) {
      this.setState({
        hasBindedDismissEvent: true
      })
      dismissButton.addEventListener('click', event => {
        event.preventDefault()
        const localStorageSupported = !!window.localStorage
        if (localStorageSupported) {
          window.localStorage.setItem(bannerCacheKey, 'hidden')
        }
        this.setState({
          hideBanner: true
        })
      })
    }
  }

  bindBannerClickEvent (bannerConfig) {
    const bannerLinkButton = document.querySelector('.js-banner__link')
    const bannerId = bannerConfig.id

    if (bannerLinkButton) {
      this.setState({
        hasBindedClickEvent: true
      })
      bannerLinkButton.addEventListener('click', event => {
        const payload = {
          name: bannerId,
          actionData: null,
          productsArray: [
            {
              id: bannerId,
              name: bannerId
            }
          ],
          timestamp: new Date().getTime()
        }
        reportHeaderBannerClick(payload)
      })
    }
  }

  render () {
    const { bannerConfig, hideBanner } = this.state

    if (!bannerConfig) {
      return null
    }

    const bannerContainerClassName = classNames(
      'banner-root', {
        'banner-slide-up': hideBanner
      }
    )

    return (
      <div className={bannerContainerClassName}>
        <style>{bannerConfig.css}</style>
        <div className='banner-container' dangerouslySetInnerHTML={{__html: bannerConfig.html}} />
      </div>
    )
  }
}

HeadBanner.propTypes = {
  banners: PropTypes.array.isRequired
}

export default HeadBanner



// WEBPACK FOOTER //
// ./client/components/banners/headBanner.js